import { Fragment } from 'react';

import { useRecoilState, useSetRecoilState } from 'recoil';

import { tokenSelector, userProfileSelector } from '@shared/state/atom/auth.atom';
import { UserCustomTheme } from '@shared/types';
import { useAsync } from 'react-use';

import { customThemeAtom } from '../atom/theme.atom';
import { useAuth } from './useAuth';

const TokenProvider: React.FC<any> = ({ children }) => {
  const { getMe } = useAuth();
  //* localStorage 저장하고 이놈이 있는가에 따라서 authenticated로 판단할 수 있다.
  const [token, setToken] = useRecoilState(tokenSelector);

  //* userProfile 저장하고 이놈으로 role 등을 다 판단
  const setUserProfile = useSetRecoilState(userProfileSelector);
  const setCustomeTheme = useSetRecoilState(customThemeAtom);
  useAsync(async () => {
    if (token) {
      const userProfile = await getMe(token);
      if (userProfile) {
        setUserProfile(userProfile);
        setCustomeTheme(userProfile.info.theme ?? UserCustomTheme.Default);
      } else {
        // console.log('redirect 해야함');
      }
    }
  }, [token]);

  return <Fragment>{children}</Fragment>;
};

export { TokenProvider };
